import { FC } from 'react'

import { Cluster, Grid, GridItem, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'
import { Brand, Header, Layout, Navigation, NavigationList } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from './footer'
import { WidgetSkeleton } from './widgetSkeleton'

const HeaderSkeleton: FC = () => {
  return (
    <Header
      logo={<Brand suffix={<Skeleton variant="badge" />} />}
      search={<Skeleton variant="button" fullWidth />}
      actions={
        <Cluster gap={8} y="center">
          <Skeleton variant="button" />
          <Skeleton variant="button" />
        </Cluster>
      }
      cockpit={
        <>
          <Skeleton variant="avatar" />
          <Skeleton variant="avatar" />
        </>
      }
    />
  )
}

const NavigationSkeleton: FC = () => {
  return (
    <>
      <Navigation>
        <NavigationList>
          <Stack gap={8}>
            <Cluster gap={16}>
              {Array.from({ length: 4 }).map((_, index) => (
                <Cluster gap={8} key={index} y="center">
                  <Skeleton variant="icon" />
                  <Skeleton variant="badge" />
                </Cluster>
              ))}
            </Cluster>
            <Stack />
          </Stack>
        </NavigationList>
      </Navigation>
    </>
  )
}

export const AppSkeleton: FC = () => {
  return (
    <Layout
      header={<HeaderSkeleton />}
      navigation={<NavigationSkeleton />}
      sidebar={<WidgetSkeleton count={2} />}
      title={<Skeleton variant="badge" />}
      main={
        <Stack gap={24}>
          <Grid col={12} gap={8}>
            <GridItem span={3}>
              <Skeleton variant="button" fullWidth />
            </GridItem>
            <GridItem span={2}>
              <Skeleton variant="button" fullWidth />
            </GridItem>
            <GridItem span={5} />
            <GridItem span={2}>
              <Skeleton variant="button" fullWidth />
            </GridItem>
          </Grid>
          <Skeleton variant="card" fullWidth />
        </Stack>
      }
      footer={<Footer />}
    />
  )
}
